import React, { FC } from 'react';

import {
  BORDER_BACKGROUND_GRADIENT_FIELDS,
  CLASSIC_UPLOAD_FIELDS
} from '../ProgressBarFormFields.consts';

import { ProgressBarDesignSection } from './ProgressBarDesignSection';
import { ProgressBarFrameSection } from './ProgressBarFrameSection';

export const ClassicProgressBarFields: FC = (): React.ReactElement => (
  <React.Fragment>
    <ProgressBarFrameSection />

    <ProgressBarDesignSection
      gradientFields={BORDER_BACKGROUND_GRADIENT_FIELDS}
      uploadFields={CLASSIC_UPLOAD_FIELDS}
    />
  </React.Fragment>
);
